module.exports = __webpack_public_path__ + "img/grey-krivaya.cca9abbc.png";